import React from 'react';
import moment from 'moment-timezone';
import { WarningOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { Wrapper, FilterCreation, FilterName } from './styled';

const fmt = 'HH:mm:ss, MMM DD YYYY';

interface IPolicy {
  filter_name: string;
  filter_created: Date;
  filter_text: string;
}

interface IProps {
  policy: IPolicy;
  index: number;
  rowIndex: number;
  sortable: boolean;
}

const PolicyFilter: React.FC<IProps> = ({ policy, index, rowIndex, sortable }) => (
  <Wrapper>
    <FilterName title={policy.filter_text} placement="topRight">
      {rowIndex}.{policy.filter_name}
    </FilterName>
    <FilterCreation className="filter-creation">
      Filter created at {moment(policy.filter_created).format(fmt)}{' '}
      {!sortable && index !== rowIndex && (
        <Tooltip title="Policy Rank not matching with Filter Sequence. Reorder Policies to fix the issue or reach out to support.">
          <WarningOutlined style={{ color: '#faad14', fontSize: 18 }} />
        </Tooltip>
      )}
    </FilterCreation>
  </Wrapper>
);

export default PolicyFilter;
